import { Table, TableCell, TableContainer, TableRow, TextField } from '@mui/material';
import styled from 'styled-components';

/**
 * Styled version of MUI components - using this instead of the sx prop
 */

export const StyledTableContainer = styled(TableContainer)`
  box-shadow: none;
  border: 1px solid ${(props) => props.theme.colors.greys.light};
  border-radius: 8px;
`;

export const StyledTable = styled(Table)`
  min-width: 448px;
`;

export const StyledTextField = styled(TextField)`
  min-width: 160px;

  & .MuiOutlinedInput-root {
    margin-right: 16px;
    & fieldset {
      border-color: ${(props) => props.theme.colors.greys.light};
    }
    &:hover fieldset {
      border-color: ${(props) => props.theme.colors.greys.dark};
    }
    &.mui-focused fieldset {
      border-color: ${(props) => props.theme.colors.greys.darkest};
    }
  }
`;

export const StyledTableHeaderCell = styled(TableCell)`
  font: ${(props) => props.theme.fonts.textBigHeight24};
  color: ${(props) => props.theme.colors.greys.darkest};

  &:last-child {
    text-align: center;
  }
`;

export const StyledTableRow = styled(TableRow)`
  &:hover {
    background-color: ${(props) => props.theme.colors.greys.lighter};
  }

  &:last-child td,
  &:last-child th {
    border: 0;
  }
`;

export const TimeSlotInfoCell = styled(TableCell)`
  padding: 12px 16px;
  min-width: 200px;
`;

export const AllocationPercentageCell = styled(TableCell)`
  padding: 12px 16px;
  min-width: 200px;
  text-align: right;

  & .MuiInputBase-input {
    text-align: center;
  }
`;
